// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"_32bbee5fda--wrapper--AZAmS","header":"_32bbee5fda--header--q8cEB","text":"_32bbee5fda--text--Tdyv1","emoji":"_32bbee5fda--emoji--rxhNJ"};